module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-114x114-61c3bf5e7a095e190fc53ef502b4765c.png";